import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DelabNgxPageTitleComponent } from '@delab/ngx-ixconnect-components';
import { Subject } from 'rxjs';
import { EventTrackerNavigationReasons } from 'src/app/shared/constants';
import { LicensesService } from '../../services/licenses.service';
import { PageCardComponent } from './page-card/page-card.component';

@Component({
    selector: 'app-start-page-circle',
    templateUrl: './start-page-circle.component.html',
    styleUrls: ['./start-page-circle.component.scss'],
    imports: [
        // Angular
        CommonModule,
        RouterModule,
        // Angular Material
        // Own
        PageCardComponent,
        DelabNgxPageTitleComponent,
    ],
})
export class StartPageCircleComponent implements OnInit, OnDestroy {
    private readonly _ngUnsubscribe = new Subject<void>();

    protected EventTrackerNavigationReasons = EventTrackerNavigationReasons;

    public readonly DEFAULT_CARD_CLASS_LEFT_POS = `left-[55%]`;
    public readonly DEFAULT_CARD_CLASS_RIGHT_POS = `right-[55%]`;
    public readonly DEFAULT_CARD_CLASSES: string = `absolute max-w-[550px]`;
    public readonly DEFAULT_BOTTOM_CARD_CLASSES: string = `bottom-0 ${this.DEFAULT_CARD_CLASSES}`;
    public readonly DEFAULT_CARD_CONTENT_CLASSES: string = `max-xl:text-sm text-xl`;
    public readonly DEFAULT_CARD_TITLE_CLASSES: string = `max-xl:text-xl! text-2xl!`;
    public readonly DEFAULT_CARD_ICON_CLASSES: string = `max-xl:text-2xl! max-xl:w-[30px]! max-xl:h-[30px]! text-3xl! w-[32px]! h-[32px]! align-bottom! leading-none!`;

    constructor(protected readonly _licenseService: LicensesService) {}

    ngOnInit(): void {}

    ngOnDestroy() {
        this._ngUnsubscribe.next();
        this._ngUnsubscribe.complete();
    }
}
